module.exports = __webpack_public_path__ + "static/media/conference.70e7042e.jpg";